var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _vm._v("后台管理系统")
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 8, offset: 8 } }, [
                          _c("a", { attrs: { href: "" } }, [
                            _c("img", {
                              staticClass: "org-img dom-center",
                              attrs: {
                                src: require("@/assets/logo.png"),
                                alt: "后台管理系统"
                              }
                            })
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }